import { useTheme } from '@mui/material';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

interface InactiveProps extends SvgIconProps {
  size?: number;
}

const Inactive: React.FC<InactiveProps> = (props) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} style={{ ...props.style, fontSize: props.size ?? 22 }} viewBox="0 0 24 24">
      <g>
        <path
          d="M12.8511 22.4463C18.3739 22.4463 22.8511 17.9691 22.8511 12.4463C22.8511 6.92344 18.3739 2.44629 12.8511 2.44629C7.32823 2.44629 2.85107 6.92344 2.85107 12.4463C2.85107 17.9691 7.32823 22.4463 12.8511 22.4463Z"
          fill={theme.palette.darkBlue.o25}
          stroke="#415965"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5.78223 5.37598L19.9222 19.516" stroke="#415965" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </SvgIcon>
  );
};

export default React.memo(Inactive);
